import { useState } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useStore } from '@app/store/useStore.hook';
import { useUpdateCustomer } from '../api/user.hooks.api';
import { usePlanLimits } from '@app/domain/plan/hooks/usePlanLimits';
import { EPlanLimitType, usePlanLimitDialog } from '@app/domain/plan/components/plan-limit-dialog/PlanLimitDialog';

export const useGPSPreferences = () => {
  const { t } = useTranslation();
  const { currentUser: user } = useStore(({ currentUser }) => ({ currentUser }));
  const { openLimitDialog: openGPSScanDialog } = usePlanLimitDialog(EPlanLimitType.GPS_SCAN);
  const { mutate: updateCustomer, isLoading } = useUpdateCustomer();
  const { canTrackGPS } = usePlanLimits();
  const [useGPS, setUseGPS] = useState(user?.shouldAskForGPSCoordinates || false);

  const disableSubmitButton = user?.shouldAskForGPSCoordinates === useGPS && canTrackGPS;

  const handleToggleGPS = () => {
    if (!canTrackGPS) {
      openGPSScanDialog();
      return;
    }
    setUseGPS((prev) => !prev);
  };

  const handleSaveChanges = () => {
    if (!canTrackGPS) {
      openGPSScanDialog();
      return;
    }
    if (user) {
      updateCustomer(
        { shouldAskForGPSCoordinates: useGPS },
        {
          onSuccess: () => {
            toast.success(t('toaster.changesSaved'));
          },
        }
      );
    }
  };

  return {
    useGPS,
    isLoading,
    disableSubmitButton,
    handleToggleGPS,
    handleSaveChanges,
    canTrackGPS,
  };
};
